/* eslint-disable no-unused-vars */

/* eslint-disable react/prop-types */

/* eslint-disable semi */

/* Import */
import React, { Component } from 'react';
import {
  AvForm,
  AvField,
  AvGroup,
  AvFeedback,
  AvInput,
} from 'availity-reactstrap-validation';
import MetaTags from 'react-meta-tags';
import { connect } from 'react-redux';
import { safeDeepGet } from 'iotera-base/utility/json';
import CryptoJS from 'crypto-js'; // pastikan terinstal
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { isMobile } from 'react-device-detect';

import Result from 'iotera-base/result';
import { safeGet } from 'iotera-base/utility/json';
import { Html5Qrcode } from 'html5-qrcode';

import {
  get_device_id,
} from '../../store/business-point/actions';

import 'tippy.js/dist/tippy.css';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { APPLICATION_ID, NAVBAR } from 'Apps';
import examplePopName from '../../assets/images/example-PopName.jpg';

import Pages403 from '../pages-403';
import { link_merchant_id } from 'Base/store/linking/actions';
const drole = localStorage.getItem('accessNav');
const jsonRole = JSON.parse(drole);

class ScanQRCode extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      modal: false,
      modalNav: false,
      Role: [],
      isLoading: false,
      uid: '',
      merchantId: '',
      deviceId: '',
      scanMode: null,
      isScanning: false,
      devices: [],
      selectedDeviceId: '',
      zoomSupported: true,
      zoom: 1.5,
      minZoom: 1,
      maxZoom: 1,
    };
    this.qrScanner = null;
    this.handleChange = this.handleChange.bind(this);
    this.videoRegionId = 'qr-reader';
    this.scannerRef = React.createRef();
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidMount() {
    // this.props.GetDeviceId({uid:"005224600c94"});
    // this.setState({
    //   isScanning: false,
    //   merchantId: 'G2323223',
    //   uid: '232323',
    //   deviceId: '323232',
    // });
    this.loadCameras();
  }
  async loadCameras() {
    try {
      const devices = await Html5Qrcode.getCameras();
      this.setState({
        devices,
        selectedDeviceId: devices[0]?.id || '',
      });
    } catch (err) {
      console.error('Gagal mendapatkan kamera:', err);
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.getDeviceResult !== prevProps.getDeviceResult) {
      // Success create
      const code = safeDeepGet(this.props, ['getDeviceResult', 'code'], null);
      if (code !== null) {
        if (code === Result.SUCCESS || code === Result.HTTP.OK) {
          const body = safeDeepGet(this.props, ['getDeviceResult', 'body'], {});
          this.setState({
            isScanning: false,
            deviceId: safeDeepGet(body, 'device_id', ''),
          });
          this.showToast(
            'Device ID ditemukan: ' + safeDeepGet(body, 'device_id', ''),
            'success'
          );
        } else {
          this.showToast('Device ID Tidak ditemukan', 'error');
        }
      }
    }
    if (this.props.linkResult !== prevProps.linkResult) {
      // Success create
      const code = safeDeepGet(this.props, ['linkResult', 'code'], null);
      if (code !== null) {
        console.log(code);
        if (code === Result.SUCCESS || code === Result.HTTP.OK) {
          const body = safeDeepGet(this.props, ['linkResult', 'body'], {});
          this.showToast(
            `UID: ${this.state.uid} dan Merchant ID ${this.state.merchantId} Berhasil di Link`,
            'success'
          );
          this.setState({
            isLoading: false,
            merchantId: '',
            uid: '',
            deviceId: '',
          });
        } else if (code == -3) {
          this.showToast(
            'QRIS sudah di binding, Mohon ganti QRIS lain',
            'error'
          );
          this.setState({
            isLoading: false,
          });
        } else {
          this.showToast('Gagal Linking Merchant id', 'error');
          this.setState({
            isLoading: false,
          });
        }
      }
    }
  }
  componentWillUnmount() {
    this.stopScanner();
  }
  generateID = sn => {
    if (APPLICATION_ID == '1000000258'  || APPLICATION_ID == '1000000367') {
      if (!sn) return '0000';
      const end = sn.length;
      const start = Math.max(end - 4, 0);
      return sn.substring(start, end).padStart(4, '0');
    } else {
      return sn;
    }
  };
  handleChange(event) {
    const sn = event.target.value;
    const codeSn = this.generateID(sn);
    this.setState({ sn: event.target.value, pop_id: codeSn });
  }
  handleDeviceChange = e => {
    this.setState({ selectedDeviceId: e.target.value });
  };
  startScanner(mode) {
    if (this.state.isScanning) {
      this.stopScanner();
    }

    const { selectedDeviceId } = this.state;
    if (!selectedDeviceId) {
      console.warn('Device ID tidak dipilih');
      return;
    }

    this.setState({ scanMode: mode, isScanning: true }, () => {
      this.qrScanner = new Html5Qrcode(this.videoRegionId);

      Html5Qrcode.getCameras().then(devices => {
        if (devices && devices.length) {
          this.qrScanner
            .start(
              { deviceId: { exact: selectedDeviceId } },
              {
                fps: 10,
                facingMode: 'environment',
                qrbox: 350,
              },
              this.onScanSuccess.bind(this),
              error => console.warn('Scan error:', error)
            )
            .then(() => {
              // 🔍 Tambahan: Cek dukungan zoom setelah start
              setTimeout(() => {
                const video = document.querySelector(
                  `#${this.videoRegionId} video`
                );
                if (video && video.srcObject) {
                  const [track] = video.srcObject.getVideoTracks();
                  this.videoTrack = track;

                  const capabilities = track.getCapabilities?.();
                  const settings = track.getSettings?.();

                  if (capabilities && capabilities.zoom) {
                    this.setState({
                      zoomSupported: true,
                      zoom: settings.zoom || capabilities.zoom.min,
                      minZoom: capabilities.zoom.min,
                      maxZoom: capabilities.zoom.max,
                    });
                  }
                }
              }, 500); // sedikit delay untuk pastikan video sudah attach
            })
            .catch(err => console.error('Start scan error:', err));
        }
      });
    });
  }
  handleZoomChange = e => {
    const newZoom = parseFloat(e.target.value);
    this.setState({ zoom: newZoom });

    if (this.videoTrack) {
      this.videoTrack
        .applyConstraints({ advanced: [{ zoom: newZoom }] })
        .catch(err => console.warn('Gagal mengatur zoom:', err));
    }
  };
  stopScanner() {
    if (this.qrScanner) {
      this.qrScanner
        .stop()
        .then(() => {
          this.qrScanner.clear();
          this.qrScanner = null;
          this.setState({ isScanning: false });
        })
        .catch(err => console.error('Stop scan error:', err));
    }
  }
  parseEmvQrData(data) {
    const match = data.match(/G\d{9}/);
    if (match) {
      this.showToast('Ditemukan: ' + match[0], 'success'); // Output: G235073391
      return match[0];
    } else {
      this.showToast('Tidak ditemukan', 'error');
      return data;
    }
  }
  getDeviceParamFromUrl(url) {
    const parsed = new URL(url);
    return parsed.searchParams.get('device'); // hasil: string terenkripsi
  }
  onScanSuccess(decodedText, decodedResult) {
    const { scanMode } = this.state;
    if (scanMode === 'uid') {
      try {
        const secretKey = '430TPhQy9OoDjGSFAZFb5fkrYJ72tNQr';
        const key = CryptoJS.enc.Utf8.parse(secretKey);

        const decoded = decodeURIComponent(
          this.getDeviceParamFromUrl(decodedText)
        );
        const encryptedWordArray = CryptoJS.enc.Base64.parse(decoded);

        const cipherParams = CryptoJS.lib.CipherParams.create({
          ciphertext: encryptedWordArray,
        });

        const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        });

        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
        console.log('Hasil dekripsi:', decryptedText);

        const deviceMap = JSON.parse(decryptedText);
        this.props.GetDeviceId({ uid: deviceMap['uid'] });
        this.setState({ uid: deviceMap['uid'] });
      } catch (error) {
        this.showToast('Gagal mendapatkan UID:', 'error');
        console.error('Gagal dekripsi UID:', error);
        this.setState({ uid: 'Gagal dekripsi, Silahkan Ulangi' });
      }
    } else if (scanMode === 'merchant') {
      this.setState({ merchantId: this.parseEmvQrData(decodedText) });
    }

    this.stopScanner();
  }

  handleValidSubmit = (event, values) => {
    const { uid, merchantId, deviceId, pop_id } = this.state;

    let pop_name = pop_id;
    if (APPLICATION_ID == '1000000258'  || APPLICATION_ID == '1000000367') {
      pop_name = `PR${pop_id}`;
    } else if (APPLICATION_ID == '1000000021') {
      pop_name = `SINERGI${pop_id}`;
    }
    const payload = {
      uid,
      merchantId,
      deviceId,
      pop_id: pop_name,
    };
    this.setState({
      isLoading: true,
    });
    this.props.LinkMerchantId(payload);
  };

  showToast(msg, toastType) {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      onclick: null,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '5000',
      extendedTimeOut: '1000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
    };

    if (toastType === 'info') toastr.info(msg);
    else if (toastType === 'warning') toastr.warning(msg);
    else if (toastType === 'error') toastr.error(msg);
    else toastr.success(msg);
  }
  render() {
    const {
      uid,
      merchantId,
      deviceId,
      isScanning,
      isLoading,
      devices,
      selectedDeviceId,
    } = this.state;
    if (safeDeepGet(NAVBAR, ['Bind Merchant', 'view'], 'off') == 'off') {
      return (
        <React.Fragment>
          <style>
            {`
            @keyframes blink {
              0% { opacity: 1; }
              50% { opacity: 0; }
              100% { opacity: 1; }
            }
      
            .blinking {
              animation: blink 2s infinite;
            }
      
            .center-screen {
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              height: 100vh;
              width: 100vw;
              text-align: center;
            }
          `}
          </style>
          <Pages403 className="center-screen" />
        </React.Fragment>
      );
    }
    if (!isMobile) {
      return (
        <React.Fragment>
          <MetaTags>
            <title>Pemindaian UID dan ID Merchant</title>
          </MetaTags>
          <style>
            {`
            @keyframes blink {
              0% { opacity: 1; }
              50% { opacity: 0; }
              100% { opacity: 1; }
            }
      
            .blinking {
              animation: blink 2s infinite;
            }
      
            .center-screen {
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              height: 100vh;
              width: 100vw;
              text-align: center;
            }
          `}
          </style>
          <div className="center-screen">
            <h1 className="blinking" style={{ color: 'red' }}>
              Peringatan
            </h1>
            <h4>
              Fitur scan QR hanya tersedia jika dibuka melalui perangkat{' '}
              <strong>HP / Mobile</strong>.
            </h4>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <MetaTags>
            <title>Pemindaian UID </title>
          </MetaTags>

          <div className="page-content">
            <h2>Binding UID dan Pop Name</h2>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="cameraSelect">
                    <strong>Pilih Kamera</strong>
                  </Label>
                  <Input
                    type="select"
                    id="cameraSelect"
                    value={selectedDeviceId}
                    onChange={this.handleDeviceChange}
                  >
                    {devices.map(device => (
                      <option key={device.id} value={device.id}>
                        {device.label || `Kamera ${device.id}`}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <div style={{ marginBottom: '1rem' }}>
              <Row className="g-2">
                <Col xs="6" sm="4">
                  <Button
                    onClick={() => this.startScanner('uid')}
                    disabled={isScanning}
                    color="primary"
                    className="w-100"
                  >
                    Scan UID
                  </Button>
                </Col>
                {/* <Col xs="4" sm="4">
                  <Button
                    onClick={() => this.startScanner('merchant')}
                    disabled={isScanning}
                    color="primary"
                  >
                    Scan Merchant ID
                  </Button>
                </Col> */}
                <Col xs="6" sm="4">
                  <Button
                    onClick={() => this.stopScanner()}
                    color="danger"
                    disabled={!isScanning}
                    className="w-100"
                  >
                    Stop Scanner
                  </Button>
                </Col>
              </Row>
            </div>

            <div
              id={this.videoRegionId}
              style={{ width: '100%', marginBottom: '1rem' }}
            ></div>
            {this.state.zoomSupported && (
              <Row className="mt-4">
                <Col md={6}>
                  <FormGroup>
                    <Label for="zoomSlider">
                      Zoom: {this.state.zoom.toFixed(1)}x
                    </Label>
                    <Input
                      type="range"
                      id="zoomSlider"
                      min={this.state.minZoom}
                      max={this.state.maxZoom}
                      step="0.1"
                      value={this.state.zoom}
                      onChange={this.handleZoomChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}
            <div>
              <AvForm onSubmit={this.handleValidSubmit}>
                <AvField
                  name="uid"
                  label="UID:"
                  required
                  style={{ width: '100%', marginBottom: '0.5rem' }}
                  readOnly
                  errorMessage="UID tidak boleh kosong"
                  value={uid}
                ></AvField>
                <AvField
                  name="deviceId"
                  label="Business Point:"
                  required
                  errorMessage="Business Point tidak boleh kosong"
                  style={{ width: '100%', marginBottom: '0.5rem' }}
                  readOnly
                  value={deviceId}
                ></AvField>
                <label className="form-label">
                  Pop Name:
                  <span className="text-danger">*</span>
                </label>
                <AvGroup className="input-group mb-3" style={{ width: '100%' }}>
                  <span className="input-group-text" id="basic-addon3">
                    {APPLICATION_ID == '1000000258' || APPLICATION_ID == '1000000367'
                      ? 'PR'
                      : APPLICATION_ID == '1000000021'
                      ? 'SINERGI'
                      : ''}
                  </span>
                  <AvInput
                    id="pop_id"
                    name="pop_id"
                    placeholder="Pop Name"
                    type="number"
                    value={this.state.pop_id || ''}
                    onChange={this.handleChange}
                    required
                    aria-describedby="basic-addon3"
                  />
                  <AvFeedback>Masukkan Pop Name</AvFeedback>
                </AvGroup>
                <div className="text-center align-items-center">
                  <Row className=" text-center">
                    <Col>
                      <label className="form-label text-center">
                        Contoh Akrilik QRIS (Lokasi Pop Name):
                      </label>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <img
                        src={examplePopName}
                        alt="Contoh Akrilik QRIS Statis dengan Pop Name"
                        style={{
                          width: '100%',
                          maxWidth: '400px',
                          borderRadius: '8px',
                          border: '1px solid #ccc',
                        }}
                      />
                      <small className="text-muted d-block mt-2">
                        Pop Name biasanya terletak di atas QRIS atau di bawah
                        NMID seperti gambar di atas.
                      </small>
                    </Col>
                  </Row>
                </div>

                {/* <AvField
                  name="merchantId"
                  label="Merchant ID:"
                  required
                  errorMessage="Merchant ID tidak boleh kosong"
                  style={{ width: '100%', marginBottom: '0.5rem' }}
                  readOnly
                  value={merchantId}
                ></AvField> */}
                <div className="mt-3 mb-3 text-center">
                  {' '}
                  <Button
                    type="submit"
                    disabled={(!uid && !merchantId && !deviceId) || isLoading}
                    color="success"
                  >
                    {isLoading ? 'Loading....' : 'Submit'}
                  </Button>{' '}
                </div>
              </AvForm>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = state => ({
  getDeviceResult: safeGet(state, ['businessPoint', 'get_device_id'], {}),
  linkResult: safeGet(state, ['linking', 'link_merchant_id'], {}),
});

const mapDispatchToProps = dispatch => ({
  GetDeviceId: payload => dispatch(get_device_id(payload)),
  LinkMerchantId: payload => dispatch(link_merchant_id(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScanQRCode);
